import { useEffect, useState } from "react";
import { Button, Modal, Select, Stack, Text } from "@mantine/core";
import classes from "./ReservationPopup.module.scss";
import { StoresResponseDTO } from "@utils/api/ec";
type SelectOption = { value: string; label: string };
interface ChooseStorePopupProps {
	chooseStoreOpened: boolean;
	onClose: () => void;
	onConfirm: (selectedValue: string | null) => void;
	stores: StoresResponseDTO[] | null;
}

export default function ChooseStorePopup({
	chooseStoreOpened,
	onClose,
	onConfirm,
	stores,
}: ChooseStorePopupProps) {
	const [selectedValue, setSelectedValue] = useState<string | null>(null);
	const [selectStores, setSelectStores] = useState<SelectOption[]>([]);
	useEffect(() => {
		if (!stores) {
			return;
		}
		const data: SelectOption[] = stores.map((item) => ({
			value: String(item.id),
			label: String(item.display_name),
		}));

		setSelectStores(data);
	}, [stores]);
	return (
		<Modal.Root
			opened={chooseStoreOpened}
			onClose={onClose}
			centered
			zIndex={400}
			classNames={{ inner: classes.modalInner }}
		>
			<Modal.Overlay opacity={0.35} />
			<Modal.Content p="0" bg="white">
				<Modal.Header bg="white" py="0" mih="11.34vw">
					<Modal.CloseButton />
				</Modal.Header>
				<Modal.Body px="7.22vw" pb="7.58vw">
					<Stack gap="10.31vw">
						<Text size="4.64vw" ta="center" lh={1.2}>
							<span className="block">為提升您的服務體驗，</span>
							<span className="block">請選擇您最近的門店位置。</span>
						</Text>

						<Select
							placeholder="選擇門店"
							data={selectStores}
							bd="#E2E4E7"
							classNames={{ input: classes.selectInput }}
							comboboxProps={{ zIndex: 1000 }}
							value={selectedValue}
							onChange={(value) => setSelectedValue(value)}
						/>
						<Button
							h="9.02vw"
							w="100%"
							color="black"
							onClick={() => onConfirm(selectedValue)}
						>
							確認
						</Button>
					</Stack>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	);
}
